import styled, { css } from 'styled-components';
import { theme, RowDiv } from 'styles';

const types = {
  enabled: css`
    border: 1px solid ${theme.colors.gray200};
    background-color: #ffffff;
  `,
  focused: css`
    border: 1px solid ${theme.colors.primary600};
    background-color: #ffffff;
    box-shadow: ${theme.shadows.input};
  `,
  hovered: css`
    border: 1px solid ${theme.colors.gray500};
    background-color: #ffffff;
  `,
  disabled: css`
    border: 1px solid ${theme.colors.fill05};
    background-color: ${theme.colors.fill02};
    cursor: not-allowed;
  `,
  error: css`
    border: 1px solid ${theme.colors.alert};
    background-color: #ffffff;
    box-shadow: 0px 0px 0px 3px rgba(225, 44, 37, 0.2);
  `,
};

export const Warp = styled(RowDiv)`
  align-items: center;
  ${({ $label }) => $label && 'gap: 10px'};
`;

export const Container = styled.div`
  position: relative;
  min-width: 120px;
  ${({ $flex }) => $flex && 'width: 100%'};
`;

export const DropBox = styled.div`
  display: flex;
  padding: 4px 10px;
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  height: ${({ $height }) => ($height ? `${$height}px` : '40px')};
  border-radius: 5px;
  gap: 10px;
  background-color: #ffffff;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 150ms;

  ${({ open, disabled }) => (disabled ? types.disabled : open ? types.focused : types.enabled)};

  &:hover {
    ${({ open }) => !open && types.hovered};
  }
`;

export const List = styled.ul`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  gap: 2px;
  max-height: ${({ $maxHeight }) => `${$maxHeight}px` || '142px'};
  background-color: #ffffff;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  width: 100%;
  overflow-y: auto;
  box-shadow: ${theme.shadows.box};
  transition: all 150ms ease;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.scroll50};
    border-radius: 10px;
  }
`;

export const ListItem = styled.li`
  cursor: pointer;
  padding: 8px 12px;
  background-color: ${({ selected, theme }) => (selected ? theme.colors.gray85 : '#ffffff')};

  &:hover {
    background-color: ${theme.colors.gray100};
  }
`;
